import { atomWithLocalStorage } from "../comments/comments";

export type WikiSectionsExpansion = Record<string, boolean>;

export const INITIAL_WIKI_SECTION_EXPANSION_STATE: WikiSectionsExpansion = {};

export const WikiSectionsExpansionAtom = atomWithLocalStorage(
    "WIKI_SECTION_EXPANSION",
    INITIAL_WIKI_SECTION_EXPANSION_STATE,
    []
);

export const setWikiSectionsExpansionStatus = (setState, sectionID, isExpanded) => {
    setState((state: WikiSectionsExpansion) => {
        const newState = { ...state };

        newState[sectionID] = isExpanded;

        return newState;
    });
};
